
<template>
  <div>
    <template v-if="loading">
      <h1>Chargement...</h1>
    </template>

    <template v-else-if="notFound">
      <div class="notification is-danger">
        Ce dossier n'existe pas.<br>
        <router-link to="/" exact>Aller sur la page principale</router-link>
      </div>
    </template>

    <template v-else>
      <h1>Dossier {{ directoryName }}</h1>
      <h2>{{ files.length }} fichier(s) ({{ directorySize }})</h2>

      <a class="button is-small" :href="`${rootUrl}/dossier/${directoryId}/files/download`" target="_blank">
        <span>Télécharger tout</span>
      </a>
      
      <ul class="block">
        <li v-for="file in files">
          {{ file.realName }} ({{ file.size }})<br>
          <code><a :href="`${rootUrl}/dossier/${directoryId}/${file.name}`" :id="`file-${directoryId}-address`" target="_blank">{{rootUrl}}/dossier/{{directoryId}}/{{ file.name }}</a></code>
          <a class="button is-small copiable" :data-clipboard-target="`#file-${directoryId}-address`">
            <span>Copier</span>
          </a>
          <a class="button is-small" :href="`${rootUrl}/dossier/${directoryId}/${file.name}`" target="_blank">
            <span>Ouvrir</span>
          </a>
          <a class="button is-small" :href="`${rootUrl}/dossier/${directoryId}/${file.name}?download`" target="_blank">
            <span>Télécharger</span>
          </a>
        </li>
      </ul>
      <span></span>
    </template>
  </div>
</template>

<script>
  import Clipboard from 'clipboard'
  import axios from 'axios'

  import {getRootUrl} from '../../helpers/url'

  export default {
    data () {
      return {
        rootUrl: getRootUrl(),
        directoryId: '',
        clipboard: null,
        loading: true,
        notFound: false,
        directoryName: '',
        directorySize: 0,
        files: []
      }
    },
    async mounted () {
      this.clipboard = new Clipboard('.copiable')
      this.clipboard.on('success', function (e) {
        e.clearSelection()

        e.trigger.innerHTML = 'Copié'
        setTimeout(() => { e.trigger.innerHTML = 'Copier' }, 2000)
      })

      this.directoryId = this.$route.params.directoryId
      try {
        const res = await axios.get(`${this.rootUrl}/api/directory/${this.directoryId}`)
        this.directoryName = res.data.directoryName
        this.directorySize = res.data.directorySize
        this.files = res.data.files
        console.log(res);
      } catch (err) {
        if (err.response && err.response.status === 404) this.notFound = true
      } finally {
        this.loading = false
      }
    }
  }
</script>

<style lang="sass" scoped>
  .notification
    a
      color: #fff
      text-decoration: underline

  ul
    li
      margin-bottom: 20px

      list-style-type: none

      &:last-of-type
        margin-bottom: 0
</style>



// WEBPACK FOOTER //
// Directory.vue?7dae69bc